/** @deprecated Legacy test keys removed — master testing key (Rule 6) is the sole bypass. */

export function isMasterSandboxUser(user: { masterTestingOverride?: boolean; testOverride?: boolean } | null) {
  return Boolean(user?.masterTestingOverride || user?.testOverride);
}

export function getSandboxWelcomeMessage(user: { role?: string; masterTestingOverride?: boolean } | null) {
  if (!isMasterSandboxUser(user)) return null;
  if (user?.role === 'ELT') {
    return 'Welcome to your organisation Learning Space. Your organisation-linked classroom workspace is ready — enrolment tools and learning utilities are active for this session.';
  }
  return 'Welcome to the Mentology Classroom Learning Space. Your private student workspace is ready — begin your Socratic session whenever you are prepared.';
}
